<template>
  <t-vdxb-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <form v-if="show_form" class="t-vdxb-application-invite-user-summary__form" @submit.prevent="handleSubmitForm">
      <div class="t-vdxb-application-invite-user-summary__fields">
        <m-application-summary>
          <a-vdxb-heading tag="h4" heading="契約名義種別" class="t-vdxb-application-invite-user-summary__heading" />
          <a-vdxb-application-summary-item :title="summaryContract.title">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="summaryContract.description" />
          </a-vdxb-application-summary-item>
        </m-application-summary>

        <m-application-summary>
          <a-vdxb-heading tag="h4" heading="契約情報" class="t-vdxb-application-invite-user-summary__heading" />
          <template v-for="(item, index) in summaryList" :key="index">
            <a-vdxb-application-summary-item :title="item.title" :variant="item.variant" :notes="item.notes">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="item.description" />
            </a-vdxb-application-summary-item>
          </template>
        </m-application-summary>
        <m-application-summary v-if="summaryCompany">
          <a-vdxb-heading tag="h4" heading="契約情報(法人)" class="t-vdxb-application-invite-user-summary__heading" />
          <template v-for="(item, index) in summaryCompanyList" :key="index">
            <a-vdxb-application-summary-item :title="item.title" :variant="item.variant" :notes="item.notes">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="item.description" />
            </a-vdxb-application-summary-item>
          </template>
        </m-application-summary>
        <m-application-summary>
          <a-vdxb-heading tag="h4" heading="ご請求書の送付先" class="t-vdxb-application-invite-user-summary__heading" />
          <template v-for="(item, index) in summaryList2" :key="index">
            <a-vdxb-application-summary-item :title="item.title" :variant="item.variant" :notes="item.notes">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="item.description" />
            </a-vdxb-application-summary-item>
          </template>
        </m-application-summary>
      </div>
      <div class="t-vdxb-application-invite-user-summary__buttons">
        <m-button-container>
          <a-vdxb-button
            id="next"
            variant="block"
            submit="submit"
            color="primary"
            :disabled="hasErrorflg || !flagApplyButtonEnable"
            >この内容で申し込む</a-vdxb-button
          >
          <a-vdxb-button id="back" color="primary" @click="handleCancelClick">戻る</a-vdxb-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-vdxb-modal
        v-model:visible="resultModalVisible"
        class="o-vdxb-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-vdxb-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-vdxb-text>
        <template #footer>
          <a-vdxb-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-vdxb-modal>
    </teleport>
  </t-vdxb-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TVdxbDefaultEntrySidebar from '@/components/templates/vdxb-default-entry-sidebar';
import MApplicationSummary from '@/components/molecules/application-summary';
import AVdxbApplicationSummaryItem from '@/components/atoms/vdxb-application-summary-item';
import AVdxbButton from '@/components/atoms/vdxb-button';
import MButtonContainer from '@/components/molecules/button-container';

import { messageContent } from '@/common/messageContent.js';
import OVdxbModal from '@/components/organisms/vdxb-modal';
import { customRequest } from '@/common/customRequest.js';
import { utils } from '@/common/utils.js';
import { JOBS } from '@/libs/constants';
import dayjs from 'dayjs';

export default {
  name: 't-vdxb-application-invite-user-summary',
  components: {
    TVdxbDefaultEntrySidebar,
    MApplicationSummary,
    AVdxbApplicationSummaryItem,
    AVdxbButton,
    MButtonContainer,
    OVdxbModal,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // summaryList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    //handleFormSubmit: {
    //  type: Function,
    //  default: () => {},
    //},
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      hasErrorflg: false,
      sidebarInfo: {
        sidebarList: [
          { label: '契約情報の入力' },
          { label: '本人確認書類' },
          { label: '請求書送付先' },
          { label: 'お申し込み内容確認' },
        ],
        sidebarCurrent: 4,
        heading: 'お申し込み内容確認',
        subHeading: 'Step 4',
        sidebarSubHeading: 'Sign Up',
        sidebarHeading: '新規お申し込み',
      },
      summaryContract: {
        title: '契約名義種別',
        description: '法人名義のお申し込み',
      },
      summaryList: [
        { title: '姓', description: this.$route.params.lastname },
        { title: '名', description: this.$route.params.name },
        { title: 'フリガナ（姓）', description: this.$route.params.lastname_kana },
        { title: 'フリガナ（名）', description: this.$route.params.name_kana },
        {
          title: '生年月日',
          description: this.$route.params.year + '年' + this.$route.params.month + '月' + this.$route.params.day + '日',
        },
        { title: 'メールアドレス', description: this.$route.params.email },
        { title: '法人名', description: this.$route.params.company_name },
        { title: '電話番号', description: this.$route.params.phone_number, variant: 'alphanumeric' },
        { title: '郵便番号', description: this.$route.params.postal_code, variant: 'alphanumeric' },
        {
          title: '住所',
          description: this.$route.params.street_address,
        },
        { title: '販売担当者氏名（姓名）', description: this.$route.params.salesperson },
        { title: '販売担当者メールアドレス', description: this.$route.params.salesperson_email },
        {
          title: '利用予定の電話番号数（ご利用開始から1ヶ月間）',
          description: this.$route.params.expectednumber_phonenumber,
        },
        { title: '利用予定の電話番号数の最大値', description: this.$route.params.expectedmaxnumber_phonenumber },
        {
          title: '利用予定の電話発信回数（1ヶ月あたり）の最大値',
          description: this.$route.params.expectedmaxnumber_outgoingcalls,
        },
        {
          title: '利用予定の電話着信回数（1ヶ月あたり）の最大値',
          description: this.$route.params.expectedmaxnumber_incomingcalls,
        },
        { title: '利用目的', description: this.$route.params.purpose },
      ],
      summaryList2: [],
      summaryCompanyList: [],
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      show_form: false,
      summaryCompany: false,
      flagApplyButtonEnable: true, //#1892
      tmpUUID: '',
      tmpYMD: '',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      jobs: [],
    };
  },
  // created() {
  //   console.log(this.$route.params.toukiFile0);
  //   console.log(this.$route.params.toukiFile1);
  //   console.log(this.$route.params.toukiFile2);
  //   console.log(this.$route.params.toukiFile3);
  //   console.log(this.$route.params.toukiFile4);
  //   console.log(this.$route.params.toukiFile5);
  //   console.log(this.$route.params.toukiFile6);
  //   console.log(this.$route.params.toukiFile7);
  //   console.log(this.$route.params.toukiFile8);
  //   console.log(this.$route.params.toukiFile9);
  //   console.log(this.$route.params.inninFile0);
  //   console.log(this.$route.params.honninFile0);
  //   console.log(this.$route.params.honninFile1);
  // },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-application-invite-user-summary', this.variant);
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async mounted() {
    document.title = 'お申し込み内容確認 | COTOHA Voice DX Basic';

    utils.setMetaDescription(this.$route);
    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: '/vdxbsignup' });
      return; // #2314
    }

    //    let companyID = this.$route.query.companyID;
    this.jobs = JOBS;
    this.fetchTmpDataHandler();
    this.show_form = true;
  },
  methods: {
    async handleSubmitForm(e) {
      this.flagApplyButtonEnable = false; //#1892
      e.preventDefault();
      const res = await this.handleSendMail();
      this.flagApplyButtonEnable = true; //#1892
      return res;
    },
    handleSendMail() {
      const documentID = this.tmpUUID;
      const key = this.tmpYMD;

      fetch('/signup/sendmail', {
        method: 'POST',
        body: JSON.stringify({
          tmpCompanyID: this.tmpUUID,
          tmpYMD: this.tmpYMD,
          _csrf: this.csrfToken,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('/signup/sendmail response was not ok.');
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.status === 'failed') {
            if (e.msg) {
              this.showErrorModal(e.msg);
            } else {
              this.$router.push({ path: '/vdxbsignup' });
            }
          } else {
            this.$router.push({ path: '/vdxbsignup/complete' });
          }
          return;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('メール送信'));
          this.flagApplyButtonEnable = true; //#1892
        });
    },
    handleCancelClick() {
      // this.$router.push({ path: '/vdxbsignup/form', query: this.$route.query });
      this.$router.push({ name: 'VdxbSignupInvoice', params: this.$route.params });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    fetchTmpDataHandler: async function () {
      await this.postRequest('/signup/getCollection', {
        tmpCompanyID: this.tmpUUID,
        tmpYMD: this.tmpYMD,
        collectionType: 'historyCollection',
      })
        .then(e => {
          if (e.session) {
            const e_data = e.data;
            this.postRequest('/signup/getCollection', {
              tmpCompanyID: this.tmpUUID,
              tmpYMD: this.tmpYMD,
              collectionType: 'certificateCollection',
            })
              .then(e => {
                if (e.session) {
                  for (const key in e.data) {
                    e_data[key] = e.data[key];
                  }

                  this.setCurrentValue(e_data);
                } else {
                  window.location.href = '/vdxbsignup';
                }
              })
              .catch(err => {
                console.log(err);
                this.showErrorModal(messageContent.requireTry('お申し込み内容確認'));
              });
          } else {
            window.location.href = '/vdxbsignup';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('お申し込み内容確認'));
        });
    },
    setCurrentValue(val) {
      const title_individual = {
        adminName: '氏名',
        adminKanaName: '氏名カナ',
        adminBirthDate: '生年月日',
        adminJob: '職業',
        adminPhoneNumber: '電話番号',
        adminEmail: 'メールアドレス',
        adminPostCode: '郵便番号',
        adminAddress1: '都道府県名',
        adminAddress2: '市区町村',
        adminAddress3: '字丁目番地など',
        adminAddress4: '住所建物など',
        purposeOfUse: '利用目的',
        salesChannelCode: '販売チャネルコード',
        salesPersonCode: '販売担当者コード',
        salesPerson: '販売担当者氏名（姓名）',
        salesPersonEmailAddress: '販売担当者メールアドレス',
        expectedNumberOfPhoneNumber: '利用予定の電話番号数（ご利用開始から1ヶ月間）',
        expectedMaxNumberOfPhoneNumber: '利用予定の電話番号数の最大値',
        expectedMaxNumberOfOutgoingCalls: '利用予定の電話発信回数（1ヶ月あたり）の最大値',
        expectedMaxNumberOfIncomingCalls: '利用予定の電話着信回数（1ヶ月あたり）の最大値',
        certificateType: '本人確認書類',
      };

      const title_company = {
        companyName: '契約名義',
        companyKanaName: '契約名義カナ',
        companyPostCode: '郵便番号',
        companyAddress1: '都道府県名',
        companyAddress2: '町村区',
        companyAddress3: '字丁目番地など',
        companyAddress4: '住所建物など',
        companyBusinessDetails: '事業内容',
        companyRulerFlag: '実質的支配者の有無',
        companyRulerName: '実質的支配者名',
        companyRulerAddress: '実質的支配者住所',
        companyRulerBirthDate: '実質的支配者生年月日',
        companyRelationship: '実質的支配者の法人との関係',
        companyRulerName2: '実質的支配者名2',
        companyRulerAddress2: '実質的支配者住所2',
        companyRulerBirthDate2: '実質的支配者生年月日2',
        companyRelationship2: '実質的支配者の法人との関係2',
        companyRulerName3: '実質的支配者名3',
        companyRulerAddress3: '実質的支配者住所3',
        companyRulerBirthDate3: '実質的支配者生年月日3',
        companyRelationship3: '実質的支配者の法人との関係3',
        companyRulerName4: '実質的支配者名4',
        companyRulerAddress4: '実質的支配者住所4',
        companyRulerBirthDate4: '実質的支配者生年月日4',
        companyRelationship4: '実質的支配者の法人との関係4',
        companyCertificateType: '法人確認書類',
      };

      const title_invoice = {
        invoicePostCode: '請求書情報（郵便番号）',
        invoiceAddress1: '請求書情報（都道府県名）',
        invoiceAddress2: '請求書情報（市区町村）',
        invoiceAddress3: '請求書情報（字丁目番地など）',
        invoiceAddress4: '請求書情報（住所建物など）',
        invoiceName: '請求書情報（送付先名）',
        invoiceKanaName: '請求書情報（送付先名カナ）',
        invoicePhoneNumber: '請求書情報（電話番号）',
      };

      this.summaryList = [];
      this.summaryList2 = [];
      this.summaryCompanyList = [];

      let inputChk = 0;
      let i = 0;
      let tmpAddress = '';
      for (const key in title_individual) {
        // 必須入力チェック
        if (
          key !== 'adminAddress4' &&
          key !== 'salesChannelCode' &&
          key !== 'salesPersonCode' &&
          key !== 'salesPerson' &&
          key !== 'salesPersonEmailAddress' &&
          key !== 'expectedNumberOfPhoneNumber' &&
          key !== 'expectedMaxNumberOfPhoneNumber' &&
          key !== 'expectedMaxNumberOfOutgoingCalls' &&
          key !== 'expectedMaxNumberOfIncomingCalls'
        ) {
          if (val[key] === '') {
            inputChk = 1;
          }
        }

        if (i < 2) {
          val[key] = val[key].replace('_', ' ');
        }

        if (i === 2) {
          val[key] = this.formatDate(val[key]);
        }

        // 職業を変換して表示用値セット
        if (key === 'adminJob') {
          const found = this.jobs.find(element => element.value === val[key]);
          if (typeof found !== 'undefined') {
            val[key] = found.label;
          }
        }

        // 住所は結合させて表示
        if (key === 'adminPostCode') {
          const pc1 = val[key].substr(0, 3);
          const pc2 = val[key].substr(3, 4);
          tmpAddress += '〒' + pc1 + '-' + pc2 + '<br>';
        }

        if (key.indexOf('adminAddress') >= 0) {
          tmpAddress += val[key];
        }

        if (key === 'adminAddress4') {
          title_individual[key] = '住所';
          val[key] = tmpAddress;
        }

        if (key === 'certificateType') {
          if (val[key] === 'driver_license') {
            val[key] = '運転免許証(表裏2枚)';
          } else if (val[key] === 'my_number_card') {
            val[key] = 'マイナンバーカード(表のみ1枚)';
          }
        }

        if (key !== 'adminPostCode' && key !== 'adminAddress1' && key !== 'adminAddress2' && key !== 'adminAddress3') {
          this.summaryList[i] = { title: title_individual[key], description: val[key] };
          i++;
        }
      }

      if (val.businessType === 'company') {
        this.summaryCompany = true;
        let i = 0;
        let tmpAddress = '';
        let tmpCertificate = '';
        let setList = true;
        for (const key in title_company) {
          if (i < 4) {
            if (key !== 'companyAddress4') {
              if (val[key] === '') {
                inputChk = 1;
              }
            }
          }

          if (key === 'companyRulerFlag') {
            if (val[key] === true) {
              val[key] = '有';
            } else {
              val[key] = '無';
            }
          }

          if (key === 'companyRulerName') {
            setList = this.chkSetList(val, 'companyRulerName');
          }

          if (key === 'companyRulerAddress') {
            setList = this.chkSetList(val, 'companyRulerAddress');
          }

          if (key === 'companyRulerBirthDate') {
            setList = this.chkSetList(val, 'companyRulerBirthDate');
          }

          if (key === 'companyRelationship') {
            setList = this.chkSetList(val, 'companyRelationship');
          }

          if (key === 'companyRulerName2') {
            setList = this.chkSetList(val, 'companyRulerName2');
          }

          if (key === 'companyRulerAddress2') {
            setList = this.chkSetList(val, 'companyRulerAddress2');
          }

          if (key === 'companyRulerBirthDate2') {
            setList = this.chkSetList(val, 'companyRulerBirthDate2');
          }

          if (key === 'companyRelationship2') {
            setList = this.chkSetList(val, 'companyRelationship2');
          }

          if (key === 'companyRulerName3') {
            setList = this.chkSetList(val, 'companyRulerName3');
          }

          if (key === 'companyRulerAddress3') {
            setList = this.chkSetList(val, 'companyRulerAddress3');
          }

          if (key === 'companyRulerBirthDate3') {
            setList = this.chkSetList(val, 'companyRulerBirthDate3');
          }

          if (key === 'companyRelationship3') {
            setList = this.chkSetList(val, 'companyRelationship3');
          }

          if (key === 'companyRulerName4') {
            setList = this.chkSetList(val, 'companyRulerName4');
          }

          if (key === 'companyRulerAddress4') {
            setList = this.chkSetList(val, 'companyRulerAddress4');
          }

          if (key === 'companyRulerBirthDate4') {
            setList = this.chkSetList(val, 'companyRulerBirthDate4');
          }

          if (key === 'companyRelationship4') {
            setList = this.chkSetList(val, 'companyRelationship4');
          }

          if (key === 'companyRulerBirthDate' && val['companyRulerFlag']) {
            if (val[key] !== '') {
              val[key] = this.formatDate(val[key]);
            }
          }

          if (key === 'companyRulerBirthDate2' && val['companyRulerFlag']) {
            if (val[key] !== '') {
              val[key] = this.formatDate(val[key]);
            }
          }

          if (key === 'companyRulerBirthDate3' && val['companyRulerFlag']) {
            if (val[key] !== '') {
              val[key] = this.formatDate(val[key]);
            }
          }

          if (key === 'companyRulerBirthDate4' && val['companyRulerFlag']) {
            if (val[key] !== '') {
              val[key] = this.formatDate(val[key]);
            }
          }

          // 住所は結合させて表示
          if (key === 'companyPostCode') {
            const pc1 = val[key].substr(0, 3);
            const pc2 = val[key].substr(3, 4);
            tmpAddress += '〒' + pc1 + '-' + pc2 + '<br>';
          }

          if (key.indexOf('companyAddress') >= 0) {
            tmpAddress += val[key];
          }

          if (key === 'companyAddress4') {
            title_company[key] = '住所';
            val[key] = tmpAddress;
          }

          if (key === 'companyCertificateType') {
            tmpCertificate = this.viewCertificateText(val);

            if (val['letterOfAttorneyURL'] !== '') {
              tmpCertificate += '委任状';
            }

            val[key] = tmpCertificate;
          }

          if (
            key !== 'companyPostCode' &&
            key !== 'companyAddress1' &&
            key !== 'companyAddress2' &&
            key !== 'companyAddress3' &&
            setList
          ) {
            this.summaryCompanyList[this.summaryCompanyList.length] = {
              title: title_company[key],
              description: val[key],
            };
            i++;
          }
          setList = true;
        }

        // サイドバーの内容を法人用に変更する
        this.sidebarInfo.sidebarList[0] = { label: '契約情報の入力' };
        this.sidebarInfo.sidebarList[1] = { label: '本人確認書類' };
        this.sidebarInfo.sidebarList[2] = { label: '契約情報の入力(法人)' };
        this.sidebarInfo.sidebarList[3] = { label: '法人の確認書類' };
        this.sidebarInfo.sidebarList[4] = { label: '請求書送付先' };
        this.sidebarInfo.sidebarList[5] = { label: 'お申し込み内容確認' };
        this.sidebarInfo.sidebarCurrent = 6;
        this.sidebarInfo.subHeading = 'Step 6';
        this.sidebarInfo.heading = 'お申し込み内容確認';
      } else {
        this.summaryContract.description = '個人名義のお申し込み';
      }

      i = 0;
      tmpAddress = '';
      for (const key in title_invoice) {
        if (key !== 'invoiceAddress4' && key !== 'invoicePhoneNumber' && key !== 'invoiceKanaName') {
          if (val[key] === '') {
            inputChk = 1;
          }
        }

        // 住所は結合させて表示
        if (key === 'invoicePostCode') {
          const pc1 = val[key].substr(0, 3);
          const pc2 = val[key].substr(3, 4);
          tmpAddress += '〒' + pc1 + '-' + pc2 + '<br>';
        }

        if (key.indexOf('invoiceAddress') >= 0) {
          tmpAddress += val[key];
        }

        if (key === 'invoiceAddress4') {
          title_invoice[key] = '請求書情報（住所）';
          val[key] = tmpAddress;
        }

        if (key === 'invoiceKanaName') {
          title_invoice[key] = '請求書情報（送付先名カナ）';
        }

        if (key === 'invoiceName') {
          if (val['adminName'] === val[key].replaceAll('　', ' ')) {
            val[key] = val['adminName'];
          }
        }

        if (
          key !== 'invoicePostCode' &&
          key !== 'invoiceAddress1' &&
          key !== 'invoiceAddress2' &&
          key !== 'invoiceAddress3'
        ) {
          this.summaryList2[i] = { title: title_invoice[key], description: val[key] };
          i++;
        }
      }

      if (inputChk === 1) {
        this.hasErrorflg = true;
        this.showErrorModal(messageContent.requireItemNotInput());
      }
    },
    chkSetList(val, key) {
      if (val['companyRulerFlag'] === '無') {
        return false;
      } else {
        if (val[key] === '') {
          return false;
        }
      }
      return true;
    },
    viewCertificateText(val) {
      for (const key2 in val) {
        if (key2.indexOf('copyOfCompanyRegisterURL') >= 0) {
          if (val[key2] !== '') {
            return '登記事項証明書<br>';
          }
        }
      }
      return '';
    },
    formatDate(val) {
      let yyyy = '';
      let mm = '';
      let dd = '';
      if (val !== '') {
        const setDate = dayjs(val);
        yyyy = setDate.format('YYYY');
        mm = setDate.format('MM');
        dd = setDate.format('DD');
      }
      return yyyy + '年' + mm + '月' + dd + '日';
    },
  },
};
</script>
